import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { Actions } from '../../actions';
import { GetArtists } from '../action-creators';
import { delay, filter, map } from 'rxjs/operators';
import { ACCEPT_INVITE_SUCCESS } from '../../invites/actions';
import { AcceptInviteSuccess } from '@webapp/store/invites/action-creators';

export const inviteAcceptedEpic = (action$: Observable<AcceptInviteSuccess>) =>
  action$.pipe(
    ofType<Actions, AcceptInviteSuccess>(ACCEPT_INVITE_SUCCESS),
    delay(5000),
    filter((action) => action.invite.type === 'team'),
    map(() => new GetArtists())
  );
